export default function SocialIcon({ name }) {
  if (name === "instagram") {
    return (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm5 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm5.5-3.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" />
      </svg>
    );
  }

  if (name === "bluesky") {
    return (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M12 10.8c-1.09-2.12-4.05-6.07-6.8-8.02C2.57.91 1.57 1.23.92 1.53.17 1.88 0 3.07 0 3.77c0 .71.39 5.82.64 6.67.84 2.83 3.83 3.79 6.58 3.48-4.78.71-9.03 2.43-3.46 8.62 6.13 6.35 8.4-1.36 8.24-5.49-.16 4.13 2.11 11.84 8.24 5.49 5.57-6.19 1.32-7.91-3.46-8.62 2.75.31 5.74-.65 6.58-3.48.25-.85.64-5.96.64-6.67 0-.7-.17-1.89-.92-2.24-.65-.3-1.65-.62-4.28 1.25-2.75 1.95-5.71 5.9-6.8 8.02Z" />
      </svg>
    );
  }

  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M5.2 7.6H1V21h4.2V7.6ZM3.1 1A2.45 2.45 0 1 0 3.1 5.9 2.45 2.45 0 0 0 3.1 1ZM21 13.3c0-4-2.1-5.9-4.9-5.9-2.3 0-3.3 1.3-3.9 2.2v-2H8V21h4.2v-7.5c0-2 .4-3.9 2.8-3.9s2.4 2.2 2.4 4V21H21v-7.7Z" />
    </svg>
  );
}
